var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container",class:{
		'icon-large': _vm.size === _vm.Size.LARGE,
		'icon-medium': _vm.size === _vm.Size.MEDIUM
	}},[_c('font-awesome-icon',_vm._b({attrs:{"fixed-width":""}},'font-awesome-icon',_vm.icon,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }